<template>
  <div>
    <v-card>
      <v-card-title>
        Configuración Columbus Life
      </v-card-title>
      <v-card-text>
        <v-textarea
            :form="form"
            label="Banner Extracurriculares"
            :error-messages="errors.collect('banner_extra')"
            v-model="form.banner_extra"
            name="banner_extra"
            v-validate="'required'"
        ></v-textarea>
        <v-textarea
            :form="form"
            label="Banner Extracurriculares"
            :error-messages="errors.collect('banner_poli')"
            v-model="form.banner_poli"
            name="banner_poli"
            v-validate="'required'"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" @click="updateSettings">Actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import Form from 'vform'
  import axios from 'axios'
  export default {
    name: 'extra-settings',
    data() {
      return {
        settings: [],
        form: new Form({
          banner_extra: '',
          banner_poli: ''
        }),
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/extracurriculares/settings')
          .then(resp => {
            if (resp.status === 200) {
              this.settings = resp.data
              this.form = new Form({
                id: this.settings.id,
                banner_extra: this.settings.banner_extra,
                banner_poli: this.settings.banner_poli
              })
            }
          })
      },
      async updateSettings() {

        if (!await this.$validator.validateAll(this.form)) return;

        this.form.put('/api/extracurriculares/settings')
          .then(resp => {
            if (resp.status === 200) {
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: 'Configuración actualizada',
                modal: false
              })
            }
          })
          .catch(error => console.log(error));
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/settings.vue